import { readonly, shallowRef, } from 'vue';

export type RouteContentErrorSource = 'component' | 'router' | 'vue';

type RouteContentError = {
  source: RouteContentErrorSource;
  occurredAt: number;
};

const currentRouteContentError = shallowRef<RouteContentError | null>(null);

export const routeContentError = readonly(currentRouteContentError);

export const captureRouteContentError = (
  source: RouteContentErrorSource
) => {
  currentRouteContentError.value = {
    source,
    occurredAt: Date.now(),
  };
};

export const clearRouteContentError = () => {
  currentRouteContentError.value = null;
};
